export default __webpack_public_path__ + "static/media/region_norrbotten_logo.2bb2545e.svg";